import { createFileRoute } from '@tanstack/react-router';
import { CreateChoice } from '../../features/choices/create';
import { choicesEditGuard } from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/neu')({
  component: CreateChoice,
  beforeLoad: choicesEditGuard,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      fieldName: (search.fieldName as string) || '',
      typeName: (search.typeName as string) || '',
    };
  },
});

export const CreateChoiceRoute = Route;
